import { GridCellProps } from '@progress/kendo-react-grid';
import { useTranslation } from 'react-i18next';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { CompanySearchResult } from 'src/types/work_area';

/**
 * Cell for management company or company (parent) column. Shows disabled tag when
 * the company record is deleted (Company Search API `isCompanyDeleted`). Contact
 * disabled state uses `isClientDeleted` and is shown in ContactNameCell only.
 */
const CompanyCell = (props: GridCellProps) => {
  const { t } = useTranslation();
  const { dataItem } = props;
  const { displayValue } = useGridCellDisplayValue(props);
  const row = dataItem as CompanySearchResult;

  return (
    <GridCellBase {...props} title={displayValue}>
      {row?.isCompanyDeleted ? (
        <div className="flex items-center justify-between gap-2 min-w-0">
          <span className="min-w-0 truncate">{displayValue}</span>
          <span className="flex-shrink-0 rounded bg-red-50 px-2 py-0.5 text-[11px] font-medium text-red-600">
            {t('disabled')}
          </span>
        </div>
      ) : (
        <span className="min-w-0 truncate">{displayValue}</span>
      )}
    </GridCellBase>
  );
};

export default CompanyCell;
